import "core-js/modules/es.array.push.js";
import SideModal from '@/components/modals/SideModal.vue';
import vClickOutside from 'v-click-outside';
import { PrescriptionService } from '@/services/prescription.service.js';
export default {
  components: {
    SideModal
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    showPricingModal: {
      type: Boolean,
      default: false
    },
    patientId: {
      type: String,
      default: ''
    },
    pricingversion: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      vcoConfig: {
        handler: this.onClickOutside,
        isActive: false
      },
      pricingList: [],
      fields: ['name', 'days', 'price']
    };
  },
  computed: {
    config() {
      return {
        ...this.vcoConfig
      };
    }
  },
  watch: {
    async showPricingModal(val) {
      if (val) {
        this.vcoConfig.isActive = true;
        this.pricingList = [];
        const {
          data
        } = await PrescriptionService.getProductDosageAndUnit(this.patientId);
        const transformedData = [];
        for (const item of data) {
          if (item.price && item.price !== 'N/A') {
            item.price = `$${item.price.toFixed(2)}`;
          }
          transformedData.push(item);
        }
        console.log(transformedData);
        this.pricingList = transformedData;
      } else {
        this.vcoConfig.isActive = false;
      }
    }
  },
  methods: {
    onClickOutside() {
      this.$emit('update:showPricingModal', false);
    }
  }
};